import { useRef } from "react";

import FAQComponent from "./components/FAQComponent";
import HeroComponent from "./components/HeroComponent";
import OffersComponent from "./components/OffersComponent";
import FooterComponent from "./components/FooterComponent";
import ProblemComponent from "./components/ProblemComponent";
import SolutionComponent from "./components/SolutionComponent";
import SubscribeComponent from "./components/SubscribeComponent";
import AboutTeamComponent from "./components/AboutTeamComponent";
import TestimonialsComponent from "./components/TestimonialsComponent";
import TopicsCoveredComponent from "./components/TopicsCoveredComponent";
import TargetAudienceComponent from "./components/TargetAudienceComponent";
import BeforeAndAfterComponent from "./components/BeforeAndAfterComponent";
import { smoothScrollToElemenHelper } from "@/helpers/smoothScrollToElementHelper";

type ScrollSection = "testimonials" | "offers";

const HomePage = () => {
  const offersSectionRef = useRef<HTMLDivElement>(null);
  const testimonialsSectionRef = useRef<HTMLDivElement | null>(null);

  const handleScrollTo = (section: ScrollSection) => {
    if (section === "testimonials" && testimonialsSectionRef.current) {
      smoothScrollToElemenHelper(testimonialsSectionRef.current);
    }
    if (section === "offers" && offersSectionRef.current) {
      smoothScrollToElemenHelper(offersSectionRef.current, 1200);
    }
  };

  return (
    <>
      <div className="min-h-screen custom-bg-color-01">
        <HeroComponent
          fnOnScrollToOne={() => handleScrollTo("offers")}
          fnOnScrollToTwo={() => handleScrollTo("testimonials")}
        />
        <TestimonialsComponent sectionRef={testimonialsSectionRef} />
        <ProblemComponent />
        <SolutionComponent />
        <BeforeAndAfterComponent />
        <OffersComponent sectionRef={offersSectionRef} />
        <TopicsCoveredComponent />
        <TargetAudienceComponent />
        <AboutTeamComponent />
        <FAQComponent />
        <SubscribeComponent fnOnScrollToOne={() => handleScrollTo("offers")} />
        <FooterComponent />
      </div>
    </>
  );
};

export default HomePage;
